import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertWindowComponent } from './alert-window.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
// import { MatDialogModule, MatButtonModule } from '@angular/material';



@NgModule({
  declarations: [AlertWindowComponent],
  entryComponents: [
    AlertWindowComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    AlertWindowComponent
  ]
})
export class AlertWindowModule { }
